import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Property } from "src/components/Properties/Property";
import industryIcon from "src/assets/icons/bag.svg";
import investmentIcon from "src/assets/icons/cash.svg";
import { CardPrice } from "src/components/Card/CardPrice";
import { propertiesTrns } from "./trns";

import { IClone } from "src/@types/clones";
import { getImageUrl } from "src/utils/getImageUrl";

const INVESTMENT_ICON = {
  title: "Investment",
  url: investmentIcon,
};

const INDUSTRY_ICON = {
  title: "Industry",
  url: industryIcon,
};

interface Props extends IClone {}

export const TopPopularCloneCardProperties: FC<Props> = ({
  industry,
  clone_cost,
  investment_for_start,
  host,
}) => {
  const { t } = useTranslation();

  const locationIcon = host?.location?.country?.icon;
  const locationAlt = host?.location?.country?.title;

  return (
    <>
      <div className="flex justify-between items-center pt-3 pb-1.5">
        <div title={locationAlt}>
          <img src={getImageUrl(locationIcon)} alt={locationAlt} />
        </div>

        <CardPrice price={clone_cost}/>
      </div>

      <Property
        className="py-1.5"
        label={t(propertiesTrns.industry)}
        value={industry?.title}
        icon={INVESTMENT_ICON}
      />

      <Property
        className="pt-1.5"
        label={t(propertiesTrns.investment)}
        value={t(propertiesTrns.investmentValue, {
          count: investment_for_start,
        })}
        icon={INDUSTRY_ICON}
      />
    </>
  );
};
